import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { MarkCheckedLeadAsReadUnread, SetCheckedLeads } from "./checked-leads.actions";


export interface CheckedLeadsModel {
  leads: number[];
  checkAll: boolean;
  markAsReadUnreadLeadId: number;
}

@State<CheckedLeadsModel>({
  name: 'CheckedLeadsModel',
  defaults: {
    leads: [],
    checkAll: false,
    markAsReadUnreadLeadId: undefined
  },
})
@Injectable()
export class CheckedLeadsState {

  private leads;

  @Selector()
  static getCheckedLeads({ leads, checkAll }: CheckedLeadsModel): {leads: number[], checkAll: boolean} {
    return { leads, checkAll };
  }

  @Selector()
  static getMarkCheckedLeadAsReadUnreadId({ markAsReadUnreadLeadId  }: CheckedLeadsModel): number | undefined {
    return markAsReadUnreadLeadId ;
  }

  @Action(SetCheckedLeads)
  setCheckedLeads(
    { patchState }: StateContext<CheckedLeadsModel>,
    { checkAll, leads }: CheckedLeadsModel
  ): void {
    this.leads = patchState({
      leads: leads,
      checkAll: checkAll
    });
  }

  @Action(MarkCheckedLeadAsReadUnread)
  markCheckedLeadAsReadUnread(
    { patchState }: StateContext<CheckedLeadsModel>,
    { leadId }: MarkCheckedLeadAsReadUnread
  ): void {
    patchState({
      markAsReadUnreadLeadId: leadId,
    });
  }

}
